import { render, staticRenderFns } from "./WaBtn.vue?vue&type=template&id=303408e0&scoped=true"
var script = {}
import style0 from "./WaBtn.vue?vue&type=style&index=0&id=303408e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303408e0",
  null
  
)

export default component.exports